
export const SurveyQuestionTypes = {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  MULTIPLE_CHOICE_SINGLE: 'MULTIPLE_CHOICE_SINGLE',
  TEXT: 'TEXT',
  YES_NO: 'YES_NO'
};
